import { render } from "./UtentiView.vue?vue&type=template&id=34894b44&scoped=true"
import script from "./UtentiView.vue?vue&type=script&lang=js"
export * from "./UtentiView.vue?vue&type=script&lang=js"

import "./UtentiView.vue?vue&type=style&index=0&id=34894b44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34894b44"]])

export default __exports__